import { connect } from 'react-redux'
import { compose } from 'redux'
import { uiRequestOverlayReset, printDataUpdateRequest, printDataPdfRequest, printDataPdfReset } from '../../../actions'
import PrintFlyer from '../present/PrintFlyer'
import { FEATURES, FLYER_DATA, UI_GENERAL  } from '../../../constants/state'
import getData from '../../../functions/getData'
import toJS from '../../../hoc/toJS'

const mapDispatchToProps = (dispatch, ownProps) => ({
    printFlyerRequest: (printFormatState, printFormat, landscape, activeWeek, printType, cinemaId, printPk, technical) => {
      dispatch(printDataPdfRequest(printFormatState, printFormat, landscape, activeWeek, printType, cinemaId, printPk, technical))
    },
    printUpdateRequest: () => {
      dispatch(printDataUpdateRequest())
    },
    onPrintFlyerPdfResetState: () => {
      dispatch(printDataPdfReset())
      dispatch(uiRequestOverlayReset())
    }
})

const mapStateToProps = state => ({
    requestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
    features: getData(state, FEATURES),
    flyerData: getData(state, FLYER_DATA)
})

const PrintFlyerContainer = ({
  params,
  features,
  flyerData,
  printFlyerRequest, 
  printUpdateRequest,
  requestOverlay,
  basicUrl,
  closePagePath,
  onPrintFlyerPdfResetState
}) => {
  const { cinemaId, printType, printFormat, landscape, week, printPk } = params
  const { hasChanges, error, status, flyers } = flyerData
  const currentFlyer = flyers ? flyers[printPk] : null

  if(!currentFlyer) {
    return ''
  }

  return (
    <PrintFlyer 
        printType={printType} 
        cinemaId={cinemaId}
        printID={printFormat}
        landscape={landscape} 
        requestStatus={status}
        printPk={printPk}
        requestError={error}
        requestOverlay={requestOverlay}
        activeWeek={week}
        hasChanges={hasChanges}
        features={features}
        // currentCinemaId={cinemaId}
        flyerData={currentFlyer}
        flyerServerData={flyerData}
        basicUrl={basicUrl}
        closePagePath={closePagePath}
        printFlyerRequest={printFlyerRequest} 
        printUpdateRequest={printUpdateRequest}
        onPrintFlyerPdfResetState={onPrintFlyerPdfResetState}
      />
    )
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(PrintFlyerContainer)

